/// <amd-module name="SuiteCommerce.PagePrinter.ItemDetailsLayout.Helper"/>
define("SuiteCommerce.PagePrinter.ItemDetailsLayout.Helper", ["require", "exports", "Handlebars"], function (require, exports, Handlebars) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var FieldType;
    (function (FieldType) {
        FieldType["Text"] = "Text";
        FieldType["Date"] = "Date";
        FieldType["Check/Cross"] = "Check/Cross";
        FieldType["QRCode"] = "QR Code";
    })(FieldType = exports.FieldType || (exports.FieldType = {}));
    var Helper = /** @class */ (function () {
        function Helper() {
            this.prepareHelpers();
            if (this.helpers)
                this.registerHandlebarsHelpers();
        }
        Helper.prototype.registerHandlebarsHelpers = function () {
            this.helpers.forEach(function (helper) {
                Handlebars.registerHelper(helper.name, helper.helperAction);
            });
        };
        return Helper;
    }());
    exports.Helper = Helper;
});
